import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import Slider from "react-slick";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

import SpQuotes from "../../img/sp-quotes.svg";

import Kyrylo_Budanov from "../../img/speaker-quotes/Kyrylo_Budanov.webp";
import Serhiy_Prytula from "../../img/speaker-quotes/Serhiy_Prytula.webp";
import Oleksandra_Matviichuk from "../../img/speaker-quotes/Oleksandra_Matviichuk.webp";
import Taras_Kytsmey from "../../img/speaker-quotes/Taras_Kytsmey.webp";
import Vasyl_Danyliak from "../../img/speaker-quotes/Vasyl_Danyliak.webp";
import Pavlo_Tsaruk from "../../img/speaker-quotes/Pavlo_Tsaruk.webp";
import Andrii_Bukin from "../../img/speaker-quotes/Andrii_Bukin.webp";
import Hennadii_Chyzhykov from "../../img/speaker-quotes/Hennadii_Chyzhykov.webp";
import Marta_Levchenko from "../../img/speaker-quotes/Marta_Levchenko.webp";
import Maryna_Pavliuk from "../../img/speaker-quotes/Maryna_Pavliuk.webp";
import Serhiy_Martynchuk from "../../img/speaker-quotes/Serhiy_Martynchuk.webp";

function Quotes() {
    const sliderRef = React.useRef(null);

    const quotesContent = [
        
        {
            name: "Кирило Буданов",
            position: "керівник Офісу президента України",
            img: Kyrylo_Budanov,
            text: "Будь-яка повномасштабна війна — це не лише боротьба армій, а й боротьба економік."
        },
        {
            name: "Сергій Притула",
            position: "засновник Благодійного фонду Сергія Притули",
            img: Serhiy_Prytula,
            text: "Масштабуватися в часи війни — це унікальні скіли, якими володіє український бізнес."
        },
        {
            name: "Олександра Матвійчук",
            position: "правозахисниця, голова Центру громадянських свобод",
            img: Oleksandra_Matviichuk,
            text: "Українські бізнеси підтримують університети, будують цифрові системи для армії, відновлюють інфраструктуру в регіонах, повертають життя у зруйновані громади. За цими історіями завжди стоять люди, часом досить вперті."
        },
        {
            name: "Тарас Китсмей",
            position: "співзасновник та член ради директорів SoftServe",
            img: Taras_Kytsmey,
            text: "Корпоративна соціальна відповідальність формує суспільство. Це той механізм, що може побудувати синергію між бізнесом і суспільством."
        },
        {
            name: "Василь Даниляк",
            position: "СЕО Групи компаній ОККО",
            img: Vasyl_Danyliak,
            text: "Компанія, яка працює прозоро, щодня думає про операційну ефективність, тоді як інші часто думають, як зекономити на податках."
        },
        {
            name: "Павло Царук",
            position: "голова правління страхової групи «ТАС»",
            img: Pavlo_Tsaruk,
            text: "В кризу дуже важлива швидкість і рішучість. Тому людям важливо розуміти сенс, розуміти, що є впевненість у майбутньому. І ти як керівник маєш це дати."
        },
        {
            name: "Андрій Букін",
            position: "заступник голови правління банку «Південний»",
            img: Andrii_Bukin,
            text: "Чим відкритіша компанія, тим більше пропозицій вона отримує від банків, а конкуренція між фінансовими установами автоматично знижує вартість кредитів і покращує умови."
        },
        {
            name: "Геннадій Чижиков",
            position: "президент Торгово-промислової палати України",
            img: Hennadii_Chyzhykov,
            text: "Європейський ринок найскладніший, але якщо ми там закріпимось, інші будуть простішими."
        },
        {
            name: "Марта Левченко",
            position: "засновниця міжнародного центру «Місто добра» і благодійного фонду «Я майбутнє України»",
            img: Marta_Levchenko,
            text: "Ми не підтримуємо формування залежності від допомоги. Ми інвестуємо у можливість людини жити далі самостійно."
        },
        {
            name: "Марина Павлюк",
            position: "генеральна директорка Glovo в Україні",
            img: Maryna_Pavliuk,
            text: "Цікаво, що AI сьогодні став частиною нашого життя абсолютно тихо і супершвидко. Те, що ще кілька років тому виглядало як майбутнє, сьогодні вже змінює не лише ефективність людей, а й саму логіку бізнесу."
        },
        {
            name: "Сергій Мартинчук",
            position: "генеральний директор Cisco Ukraine",
            img: Serhiy_Martynchuk,
            text: "Дуже важливо розуміти, навіщо компанія впроваджує штучний інтелект і який саме результат вона хоче отримати. Інакше легко витратити мільйони на інструменти, які лише імітують прогрес."
        },
    ];

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
    };

    return (
        <section className="relative">
            <div className="container max-w-screen-xl mx-auto relative z-30 px-[15px] pt-16 pb-24">
                <div className="relative bg-[linear-gradient(100deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)]
 py-8 lg:px-10 lg:py-20">
                    <img src={SpQuotes} className="hidden md:block absolute z-10 top-10 right-6 lg:right-36" alt="Quotes" />
                
                <div className="flex items-center justify-center gap-4 absolute bottom-9 left-1/2 -translate-x-1/2
                lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 lg:left-0 lg:translate-x-0 lg:justify-between w-full z-10">
                    <button className="p-3 text-white opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickPrev()}>
                        <SlArrowLeft className="text-3xl" />
                    </button>

                    <button className="p-3 text-white opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickNext()}>
                        <SlArrowRight className="text-3xl" />
                    </button>
                </div>


                <Slider
                    ref={sliderRef}
                    {...settings}
                    className="[&_.slick-track]:flex [&_.slick-track]:items-start [&_.slick-slide]:h-auto [&_.slick-slide>div]:h-full"
                >
                    {quotesContent.map((item, index) => (
                        <div className="lg:px-12" key={index}>
                            <div className="text-white flex flex-col items-center md:flex-row md:gap-6 lg:gap-10 ">

                                {/* Фото */}
                                <div className="mb-3 md:m-0 lg:w-full lg:max-w-[430px] lg:flex-shrink-0"> 
                                    <img src={item.img} className="w-full" alt={item.name} /> 
                                </div>

                                {/* Текст */}
                                <div className="relative">
                                    <img src={SpQuotes} className="absolute md:!hidden z-10 -top-10 right-6" alt="Quotes" />
                                    <h3 className="text-xl font-semibold mb-3 lg:text-3xl">
                                        {item.name}
                                    </h3>

                                    <p className="font-semibold mb-5 lg:text-lg">
                                        {item.position}
                                    </p>

                                    <div className="text-justify lg:text-base">
                                        {item.text}
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </Slider>
                </div>
            </div>
        </section>
    );
}


export default Quotes